export const environment = {
  production: false,
  firebase: {
    // apiKey: "AIzaSyDpyeudy52REJnwAq6eqM-EANrjsy5fe_0",
    // authDomain: "fudeco-company.firebaseapp.com",
    // projectId: "fudeco-company",
    // storageBucket: "fudeco-company.firebasestorage.app",
    // messagingSenderId: "480831425900",
    // appId: "1:480831425900:web:111ad72b02507683aff749",
    // measurementId: "G-LZG8Z2VHKB"
      apiKey: "AIzaSyAt4oSTgFkprnhKycrJLU6DyICEkEMAoXo",
      authDomain: "fox-badminton.firebaseapp.com",
      projectId: "fox-badminton",
      storageBucket: "fox-badminton.firebasestorage.app",
      // Realtime Database — dùng cho game đua vịt (vị trí vịt cập nhật liên tục).
      // Lấy đúng URL hiển thị trong Firebase Console → Realtime Database.
      databaseURL: "https://fox-badminton-default-rtdb.asia-southeast1.firebasedatabase.app",
      messagingSenderId: "690489045112",
      appId: "1:690489045112:web:51f966d9026f9ea9723d8d",
      measurementId: "G-BMKGLVBMNY"
  },
};
